import news from './news';
import schedules from './schedules';
import guests from './guests';

// const { mainVenue, parallelVenue, awards, workshop } = schedules;
const { recentNews, videosList, album } = news;

schedules.mainVenue.map(item => (item.affair.speakers = []));
schedules.parallelVenue.map(item => (item.affair.speakers = []));

export default {
  schedules,
  recentNews,
  videosList,
  album,
  guests,
};
